<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <form id="addGnbTaskDialog">
      <div class='row h-row-around-inputBox'>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class='h-borderBox h-filterTopoTree height-320'>
              <PmGnbTopoTree @pmGnbTopoTreeClickEventPush="pmGnbTopoTreeClickEventPush" ref='pmGnbTopoTreeRef' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true' graphType="2"></PmGnbTopoTree>
            </div>
          </div>
        </div>
        <div class='col-sm-6'>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Pm.uploadBaseTime')}}:</div>
            <ejs-datetimepicker
              format='yyyy-MM-dd HH:mm:ss'
              timeFormat='HH:mm:ss'
              step="15"
              :allowEdit=false
              :change="validateOfAddGnbTaskDialog"
              name="periodicUploadTime"
              id="periodicUploadTime"
              :locale='locale'
              v-model='periodicUploadTime'
            ></ejs-datetimepicker>
          </div>
          <div class='h-col-inputBox'>
            <div class='h-inputLit'>{{$t('Pm.alias')}}:</div>
            <div class="e-input-group e-control-wrapper">
              <input class="e-control e-textbox e-lib e-input" type="text" id="alias" name="alias" v-model="alias">
            </div>
          </div>
        </div>
        <div class='h-clear-rowMg'></div>
      </div>
    </form>
  </div>
</template>

<script>
  import {FormValidator} from "@syncfusion/ej2-vue-inputs";
  import PmGnbTopoTree from "../tree/PmGnbTopoTree";

  export default {
    name: 'AddGnbTaskDialog',
    components: {
      PmGnbTopoTree
    },
    data() {
      return {
        dateFormat: 'yyyy-MM-dd',
        periodicUploadTime: '',
        alias: '',
        locale: localStorage.getItem('locale'),
        neClickInfo: null,
        addGnbTaskValidation: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.position = 'fixed';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            periodicUploadTime: {
              required: [true, this.$t('Pm.pleaseSelectUploadBaseTime')],
              regex: [/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/, this.$t('Pm.uploadBaseTimeError')]
            },
            alias: {
              required: [true, this.$t('Pm.pleaseInputAlias')],
            }
          }
        },
        formObjOfAddGnbTaskDialog: ''
      }
    },
    methods: {

      bindValidateOfAddGnbTaskDialog(){
        this.formObjOfAddGnbTaskDialog = new FormValidator('#addGnbTaskDialog', this.addGnbTaskValidation);
      },

      validateOfAddGnbTaskDialog() {
        const formStatus = this.formObjOfAddGnbTaskDialog.validate();
        if (!formStatus) {
          return false;
        }
        return true;
      },

      pmGnbTopoTreeClickEventPush(params) {
        this.neClickInfo = {};
        this.neClickInfo = params;
      },
    },
    mounted() {
      this.bindValidateOfAddGnbTaskDialog();
    }
  }
</script>

<style scoped>
</style>
